'use client';
// Static/server-side components that don't require client-side JavaScript
export { CatDivider } from '@blocks-react/components/Divider';
export { CatTextPassage } from '@blocks-react/components/TextPassage';
export { CatFieldNote } from '@blocks-react/components/FieldNote';
export { CatBadge } from '@blocks-react/components/Badge';
export { CatFieldset } from '@blocks-react/components/Fieldset/';
